import { View } from "extensions/marionette";

import { CategoryItemList } from "./categoryItemList";
import categoryTemplate from "./category.jst";

export const Category = View.extend({
    className: "filter-category collapsed",
    template: categoryTemplate,
    events: {
        "click .category-header": "toggleItems"
    },
    regions: {
        items: {
            el: ".category-items",
            replaceElement: true
        }
    },
    
    childViewTriggers: {
        "treeitem:selected": "treeitem:selected"
    },
    
    initialize() {
        this.state = {
            expanded: false
        };
    },
    
    toggleItems(view) {
        if (!this.getChildView("items")) {
            this.showChildView("items", new CategoryItemList({
                temps: this.getOption("parent").getOption("tempQualifiers").value.filter((t) => t.category === this.model.get("ref")),
                collection: this.model.get("items")
            }));
        }
        
        this.toggleCategory(view);
    },
    
    toggleCategory() {
        this.$el.find(".category-header [data-fa-i2svg]")
            .toggleClass("fa-plus-square", this.state.expanded)
            .toggleClass("fa-minus-square", !this.state.expanded);
    
        this.$el.toggleClass("collapsed", this.state.expanded);
        
        if (!this.state.expanded) {
            // Scroll list into the view
            this.scrollIntoViewport();
        }
        
        // Store expanded state in the view
        this.state.expanded = !this.state.expanded;
    },
    
    scrollIntoViewport() {
        const $parent = this.$el.parent();
        const oldScrollTop = this.$el.parent().scrollTop();
        const newScrollTop = this.el.offsetTop - this.el.parentElement.offsetTop;
    
        // Don't animate if difference is less than 10px
        if (Math.abs(newScrollTop - oldScrollTop) < 10) {
            $parent[0].scrollTop = newScrollTop;
        } else {
            $parent.animate({
                scrollTop: newScrollTop
            }, 300);
        }
    }
});
